var map = {
	"./cwa.avif": 7829,
	"./cwa.png": 7149,
	"./erp.avif": 7069,
	"./erp.png": 2293,
	"./mbd.avif": 5649,
	"./mbd.png": 4697,
	"./pages/customize-software/Picflow Images Jun 17 (1).zip": 4723,
	"./pages/customize-software/coding-vector.avif": 7271,
	"./pages/customize-software/coding-vector.jpg": 3789,
	"./pages/customize-software/cover.avif": 7738,
	"./pages/customize-software/cover.jpeg": 4759,
	"./pages/customize-software/cs-services.avif": 6948,
	"./pages/customize-software/cs-services.jpg": 3992,
	"./pages/erp/1.avif": 6582,
	"./pages/erp/1.png": 8708,
	"./pages/erp/2.avif": 447,
	"./pages/erp/2.png": 2271,
	"./pages/erp/3.avif": 800,
	"./pages/erp/3.png": 4182,
	"./pages/mobile-application-development/1.avif": 900,
	"./pages/mobile-application-development/1.jpeg": 4893,
	"./pages/mobile-application-development/2.jpg": 2083,
	"./pages/web-application-development/1.avif": 5546,
	"./pages/web-application-development/1.jpg": 5992,
	"./wa.avif": 9840,
	"./wa.png": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1590;